import React from "react";
import Auction from "../auction/auction.component";

import LoadInfo from "../loadInfo/loadInfo.component";
import LoadTiming from "../loadTiming/loadTiming.component";
import RadioBtns from "../radioBtns/radioBtns.component";
import Weight from "../../containerSmall/weight/weight.component";
import Size from "../size/size.component";
// import Calender from "../calender/calender.component";

const SubmitReqLeftCol = () => {
  return (
    <div className="overflow-hidden">
      <LoadInfo />

      <RadioBtns />

      <LoadTiming />

      <Auction />

      <Weight />

      <Size />
    </div>
  );
};

export default SubmitReqLeftCol;
